export const GET_SUBCATEGORYDATA = 'GET_SUBCATEGORYDATA';
export const SET_SUBCATEGORYDATA = 'SET_SUBCATEGORYDATA';
export const GET_SUBCATEGORYBYID = 'GET_SUBCATEGORYBYID';
export const SET_SUBCATEGORY = 'SET_SUBCATEGORY';
export const GET_CREATEUPDATESUBCATEGORY = 'GET_CREATEUPDATESUBCATEGORY';
export const GET_SAVEDSUBCATEGORYFLAG = 'GET_SAVEDSUBCATEGORYFLAG';
export const SET_SAVEDSUBCATEGORYFLAG = 'SET_SAVEDSUBCATEGORYFLAG';
export const GET_ERRORSUBCATEGORYFLAG = 'GET_ERRORSUBCATEGORYFLAG';
export const SET_ERRORSUBCATEGORYFLAG = 'SET_ERRORSUBCATEGORYFLAG';
export const SET_SUBCATEGORYNAME = 'SET_SUBCATEGORYNAME';